import AuthContactPanel from 'components/common/AuthContactPanel';
import React from 'react';

const GroupLandingRightPanel = () => {
  return (
    <>
      <AuthContactPanel />
    </>
  );
};

export default GroupLandingRightPanel;
